import React from "react";
import { Icon } from "antd";

import styled from "styled-components/macro";

const Container = styled.div`
  background-color: ${({ theme, severity }) => theme[`@${severity}`]};
  display: inline-flex;
  align-items: center;
  border-radius: 50px;
  padding: ${({ toggled }) => (toggled ? `10px 40px 10px 10px` : `10px`)};
  color: white;
  margin-right: 80px;
  line-height: 1.5em;
  position: relative;
  cursor: pointer;
  width: fit-content;

  .anticon {
    font-size: 18px;
  }

  .close {
    position: absolute;
    right: 10px;
  }

  & + & {
    margin-top: 10px;
  }
`;

const Message = styled.div`
  margin-left: 10px;
`;

const Warning = ({ severity, children, ...props }) => {
  const [toggled, setToggled] = React.useState(true);

  return (
    <Container
      severity={severity}
      toggled={toggled}
      onClick={() => setToggled(!toggled)}
      {...props}
    >
      <Icon type="warning" />
      {toggled ? (
        <>
          <Message>{children}</Message>
          <Icon className="close" type="close" />
        </>
      ) : null}
    </Container>
  );
};

export default Warning;
